import React from 'react';
import ReactDOM from 'react-dom';
import App from 'common/components/App';
import './common/themes/globals.css';

ReactDOM.render(<App />, document.getElementById('root'));
